import ProfileCountries from "@/entities/locationEntities/ProfileCountries";

function isCountryUSA (countryName: string = "") {
  return countryName === ProfileCountries.USA;
}

export default isCountryUSA;